import { render } from "./revisarAfiliados.vue?vue&type=template&id=749c6217&scoped=true"
import script from "./revisarAfiliados.vue?vue&type=script&lang=js"
export * from "./revisarAfiliados.vue?vue&type=script&lang=js"

import "./revisarAfiliados.vue?vue&type=style&index=0&id=749c6217&scoped=true&lang=css"

import exportComponent from "E:\\Proyectos\\Front_IOSEP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-749c6217"]])

export default __exports__